import PropTypes from 'prop-types'
import { observer } from 'mobx-react-lite'
import { format } from 'date-fns/format'

import { formatNoteDescriptionFromBackend } from 'util/notes'
import useStyles from './styles'

const DefaultPluralNotesBlock = ({ type, visit }) => {
  const classes = useStyles()
  return (
    visit.notes[type]?.map((note) => (
      <div key={note.id} className={classes.noteCard}>
        {formatNoteDescriptionFromBackend(note.description)}
        <div className={classes.noteCardExtra}>
          Created by {note.createdByName}, {format(new Date(note.createdAt), 'MM/dd/y hh:mm aaa')}
        </div>
      </div>
    )) || null
  )
}
DefaultPluralNotesBlock.propTypes = {
  type: PropTypes.oneOf(['addendum']).isRequired,
  visit: PropTypes.object,
}

export default observer(DefaultPluralNotesBlock)
